import { render, staticRenderFns } from "./СustomerForm.vue?vue&type=template&id=61099696&"
import script from "./СustomerForm.vue?vue&type=script&lang=js&"
export * from "./СustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports